import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames/bind';

const CACHE = {};

// build a cache with all icons
const icons = require.context('../../../icons', true, /.*\.svg$/);
const iconNames = icons.keys();
const svgs = iconNames.map(icons);

iconNames.forEach((file, index) => (CACHE[file.match(/\.?\/(.*)\.svg$/)[1]] = svgs[index]));


/**
 * `Icon` is a component for displaying SVG icons.
 *
 * It supports displaying any of the bundled icons using *name*, or you can provide your own SVG data using the *icon* prop.
 *
 * The component will automatically scan the SVG files in the `icons` folder and use the name of the file as key (minus the
 * file extension). The *name* prop must match one of these keys in order to display an icon.
 *
 * @property {string} className The class name of your icon. Will be appended "core-icon".
 * @property {node} icon Raw SVG markup which represents your icon.
 * @property {string} name The name of any icon bundled with **vimond-core-components**. See list above for bundled icons.
 */
class Icon extends PureComponent {

  static displayName = 'Icon';

  static propTypes = {
    className: PropTypes.string,
    icon: PropTypes.node,
    name: PropTypes.string,
  };

  render() {
    const { className, icon, name, ...rest } = this.props;
    const data = name ? CACHE[name.replace('#', '')] : icon;

    if (data) {
      return (
        <span role="img" aria-label={`${name}`} {...rest} className={cx('core-icon', className, `icon-${name}` )} dangerouslySetInnerHTML={{ __html: data }}/> // eslint-disable-line react/no-danger
      );
    }
    return <span/>;
  }

}

const ICONS = Object.keys(CACHE).sort((a, b) => a.localeCompare(b));

export { ICONS };
export default Icon;
